import { ApolloError } from '@apollo/client';
import { MfaStatus, RoleEnum } from 'lib/graphql/graphql';
import { createContext } from 'react';

export interface IAuthenticatorContext {
  loggedIn: boolean
  confirmAccount: () => Promise<void>
  confirmedAccount: boolean
  login: (username: string, password: string, invitationToken?: string) => Promise<void>
  loginTotp: (totp: string) => Promise<void>
  loginRecoveryOtp: (recoveryOtp: string) => Promise<void>
  logout: () => Promise<void>
  error?: ApolloError
  firstBoot: boolean
  setFirstBoot: (firstBoot: boolean) => void
  performingLogin: boolean
  userId: string
  requireMfa: boolean
  requestRefresh: () => Promise<void>
  role: RoleEnum | null;
  loginToOrganization: (invitationId: string) => Promise<boolean>
  mfaStatus: MfaStatus
}

export const DefaultAuthenticatorContext: IAuthenticatorContext = {
  loggedIn: false,
  confirmAccount: async () => {},
  confirmedAccount: false,
  login: async () => {},
  loginTotp: async () => {},
  loginRecoveryOtp: async () => {},
  logout: async () => {},
  performingLogin: false,
  userId: '',
  requireMfa: false,
  firstBoot: true,
  setFirstBoot: () => {},
  requestRefresh: async () => {},
  role: null,
  loginToOrganization: async () => false,
  mfaStatus: MfaStatus.Disabled,
};

const AuthenticatorContext = createContext(DefaultAuthenticatorContext);
export default AuthenticatorContext;
